import { SKU_TYPE } from './src/constants';
import { setApi, setEnv } from './src/init';
import { openPaymentModal } from './src/paymemt-modal';
import { openPaymentSuccessModal } from './src/paymemt-success-modal';
import { getIsMobileUa } from './src/utils/ua';

export { openPaymentModal } from './src/paymemt-modal';
export { openPaymentSuccessModal } from './src/paymemt-success-modal';
export { useMobilePay } from './src/paymemt-modal/hooks/useMobilePay';

export { default as Lingdou } from './src/components/lingdou.vue';
export { default as VipTag } from './src/components/vip-tag.vue';

export { SKU_TYPE } from './src/constants';

// 初始化商业化组件，使用该包时必须先调用init
export function init(params: { defHttp: any; env: string }) {
  setApi(params.defHttp);
  setEnv(params.env);
}

// 打开支付弹窗
export function openPayModal(params: {
  // 获取用户信息
  getUserInfo: Function;

  // 获取租户信息
  getOrgInfo: Function;

  // 获取灵豆信息
  getLingdouInfo: Function;

  // 支付成功回调
  onPaySuccess?: Function;

  // 取消支付回调
  onPayCancel?: Function;

  // 默认选中的sku id
  defaultActiveSkuId?: number;

  // 默认选中的sku的交易号（一般用于待支付订单场景）
  defaultActiveSkuTradeNo?: string;

  // 是否只展示被选中的sku
  onlyShowActiveSku?: boolean;

  // 支付成功弹窗点击确认按钮回调
  onPaymentSuccessModalOk?: Function;

  // 支付成功弹窗点击取消按钮回调
  onPaymentSuccessModalCancel?: Function;

  // 支付成功弹窗点击关闭按钮回调
  onPaymentSuccessModalClose?: Function;

  // 跳转成员管理页面
  onGoMemberPage?: Function;

  onlyLingdou?: boolean;

  // 默认定位的tab下
  defaultActiveTab?: SKU_TYPE;

  // 弹窗层级，只有pc端生效
  zIndex?: number;

  // 手机打开支付弹窗，微信支付时需要传入
  wxConfig: {
    appid: string;
    openid: string;
    payRedirectUri: string;
  };

  // 手机打开支付弹窗，支付宝支付时需要传入
  zfbConfig: {
    payRedirectUri: string;
  };
}) {
  const isMobileUa = getIsMobileUa();

  openPaymentModal({
    getUserInfo: params.getUserInfo,
    getOrgInfo: params.getOrgInfo,
    getLingdouInfo: params.getLingdouInfo,
    defaultActiveSkuId: params.defaultActiveSkuId,
    onlyLingdou: params.onlyLingdou,
    defaultActiveTab: params.defaultActiveTab,
    onGoMemberPage: isMobileUa ? undefined : params.onGoMemberPage,
    defaultActiveSkuTradeNo: isMobileUa ? undefined : params.defaultActiveSkuTradeNo,
    onlyShowActiveSku: isMobileUa ? undefined : params.onlyShowActiveSku,
    wxConfig: isMobileUa ? params.wxConfig : undefined,
    zfbConfig: isMobileUa ? params.zfbConfig : undefined,
    zIndex: isMobileUa ? undefined : params.zIndex,
    // 支付成功回调
    onPaySuccess(result) {
      // 支付成功后，打开支付成功弹窗
      openPaymentSuccessModal({
        getOrgInfo: params.getOrgInfo,
        getLingdouInfo: params.getLingdouInfo,
        tradeNo: result.tradeNo,
        onOk() {
          params.onPaymentSuccessModalOk?.();
        },
        onCancel() {
          params.onPaymentSuccessModalCancel?.();
        },
        onClose() {
          params.onPaymentSuccessModalClose?.();
        },
      });
      params?.onPaySuccess?.(result);
    },
    // 取消支付回调
    onPayCancel() {
      params?.onPayCancel?.();
    },
  });
}
